import React from 'react'
import { func, object } from 'prop-types'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'
import { stores, view } from '../../../stores'
import { Loader } from '../../../components/ui/states/Loader'
import { InquiryTypes } from '../../../constants/InquiryTypes'
import { InquiryFrequencies } from '../../../constants/InquiryFrequencies'
import { InquiryPage } from '../InquiryPage'
import { ProposalsWaiting } from './ProposalsWaiting'
import { InquiryDetails } from '../../../components/inquiries/InquiryDetails'
import { InquiryStatus } from '../../../constants/InquiryStatus'
import { PagesPaths } from '../../../constants/Pages'

class InquiryVisitPageComponent extends InquiryPage {
  get type () { return InquiryTypes.VISIT }
  get frequency () { return InquiryFrequencies.PONCTUAL }

  async onCloseSearch () {
    const { history } = this.props
    await stores.inquiries.close()
    if (stores.inquiries.inquiry.status === InquiryStatus.CANCELLED) {
      history.push(PagesPaths.INQUIRIES.path)
    }
  }

  render () {
    const { inquiry } = stores.inquiries

    if (!this.ready) {
      return (<Loader />)
    }
    return (
      <InquiryDetails inquiry={inquiry} account={stores.account.connected} onCloseSearch={() => this.onCloseSearch()}>
        <ProposalsWaiting inquiry={inquiry} type={this.type} frequency={this.frequency} />
      </InquiryDetails>
    )
  }
}

InquiryVisitPageComponent.propTypes = {
  t: func,
  match: object
}

export const InquiryVisitPage = withRouter(translate()(view(InquiryVisitPageComponent)))



// WEBPACK FOOTER //
// ./src/pages/demandes/visits/InquiryVisitPage.js